// extracted by mini-css-extract-plugin
export var body = "_kv-8";
export var button = "_kv-0";
export var closeButton = "_kv-5";
export var content = "_kv-3";
export var empty = "_kv-f";
export var grid = "_kv-c";
export var header = "_kv-4";
export var icon = "_kv-1";
export var option = "_kv-d";
export var optionSelected = "_kv-e";
export var overlay = "_kv-2";
export var searchIcon = "_kv-a";
export var searchInput = "_kv-b";
export var searchWrapper = "_kv-9";
export var title = "_kv-6";
export var visuallyHidden = "_kv-7";